<template>
  <div id="app">
    <chat-wrap></chat-wrap>
  </div>
</template>

<script>
import ChatWrap from './components/ChatWrap'

export default {
  name: 'App',
  components: {
    ChatWrap
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue